<template>
  <b-input-group :class="`size-${size}`">
    <b-input-group-append v-if="iconLeft">
      <b-button variant="ghost-dark" @click="$emit('on-search')">
        <al-icon icon="search" />
      </b-button>
    </b-input-group-append>
    <b-form-input
      v-model="search"
      :placeholder="placeholder"
      debounce="1000"
      autofocus
      test-id="al-search"
    />
    <b-input-group-append v-if="!iconLeft">
      <b-button variant="ghost-dark" @click="$emit('on-search')">
        <al-icon icon="search" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { BFormInput, BInputGroup, BInputGroupAppend, BButton } from 'bootstrap-vue';
import AlIcon from '../../inline/icon/AlIcon.vue';

export default {
  components: {
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BButton,
    AlIcon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    iconLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    }
  },
  data() {
    return {
      search: ''
    };
  },

  watch: {
    value(val) {
      this.search = val;
    },
    search(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss" scoped>
$border-radius: 4px;
$height: 36px;

.input-group {
  input {
    background: #f4f4f4;
    border: 0;
    border-radius: $border-radius;
    height: $height;

    &::placeholder {
      color: #b0b0b0;
      font-size: 16px;
    }
  }

  > .form-control:not(:last-child) {
    border-radius: $border-radius;
  }
}

.input-group-append {
  position: relative;

  .btn {
    align-items: center;
    color: black;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 0 5px;
    position: absolute;
    right: 100%;
    z-index: 3;
  }
}

// Large
.input-group.size-lg {
  padding-bottom: spacing(6);

  input {
    background: color(white, lighten, 1);
    border: 1px solid color(white, darken, 2);
    border-radius: 0 $br-default $br-default 0;
    height: 56px;
    padding: spacing(none) spacing(5);

    &:focus {
      border-color: color(green);
      box-shadow: $bs-material-5;
    }
  }

  .input-group-append {
    background-color: color(white);
    border: 1px solid color(white, darken, 2);
    border-radius: $br-default 0 0 $br-default;
    border-right: 0;
    height: 56px;
    padding: spacing(4);
    position: static;
    width: 56px;

    .btn {
      color: color(black, lighten, 2);
      padding: spacing(none);
      position: static;

      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
